import { defineMessages } from 'react-intl';

export default defineMessages({
  suspended: 'Przerwane',
  started: 'W trakcie',
  ended: 'Zakończone',
  paused: 'Wstrzymane',
  link: 'Link',
});
